<template>
  <div class="home-wrap">
    <div class="home-bg flex-box flex-column">
      <div class="flex-box">
        <img src="../assets/logo.png" alt="" class="home-logo" />
        <span class="logo-text">{{$t('中国人成骨不全症变异数据库（COIMD）')}}</span>
      </div>
      <div class="search-box">
        <div class="input-box flex-1">
          <span class="icon search-icon"></span>
          <el-select v-model="searchVal" placeholder="下拉选择致病基因" class="search-input">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.gene"
              :value="item.gene">
            </el-option>
          </el-select>
        </div>
        <div class="search-btn" @click="goToList">{{$t('查询')}}</div>
      </div>
      <p class="desc">
        {{$t('中国人成骨不全症')}}
      </p>
    </div>
  </div>
</template>

<script>
  import {getGene} from '@/request/api';
export default {
  name: '',

  data () {
    return {
      searchVal: '',
      options: []
    }
  },
  created () {
    getGene().then(res => {
      this.options = res
    })
  },

  methods: {
    goToList () {
      this.$router.push({
        path: '/pathogen',
        query: {
          search: this.searchVal
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.home-wrap {
  background: #fff;
  margin: 0 auto;
  width: 100%;
  .home-bg {
    background: url('../assets/home_bg.png');
    background-position: center center;
    height: 784px;
    background-size: 1779px 784px;
    background-repeat: no-repeat;
    .home-logo {
      height: 70px;
      margin-top: 153px;
      border-radius: 50%;
      margin-right: 20px;
    }
    .logo-text {
      font-size: 32px;
      font-weight: 500;
      margin-top: 153px;

      color: #333;
    }
    .search-box {
      margin-top: 68px;
      height: 94px;
      background: #fff;
      width: 1100px;
      box-shadow: 0px 28px 74px 0px rgba(0, 0, 0, 0.22);
      display: flex;
      .search-input {
        border: none;
        outline: none;
        font-size: 16px;
        // padding-left: 120px;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        &::placeholder {
          color: #8C97AC;
        }
      }
      .input-box {
        position: relative;
      }
      .icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        position: absolute;
        background-size: 100%;
        top: 50%;
        margin-top: -10px;
        &.search-icon {
          background-image: url('../assets/icon/search-icon.png');
          left: 30px;
          z-index: 1;
        }
        &.arrow-icon {
          background-image: url('../assets/icon/arrow-icon.png');
          right: 60px;
        }
      }
      .search-btn {
        width: 252px;
        height: 100%;
        background: #22B0FC;
        color: #fff;
        cursor: pointer;
        font-size: 20px;
        text-align: center;
        line-height: 94px;
        &:hover {
          opacity: .9;
        }
      }
    }
    .desc {
      width: 800px;
      margin-top: 90px;
      font-size: 18px;
      color: #333333;
    }
  }
}
</style>
